import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observer } from 'mobx-react';
import * as React from 'react';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { LoadingState } from '../../../shared/api/LoadingState';
import rootStore from '../../../shared/stores/RootStore';
import { FormStore } from '../../../shared/stores/shared/FormStore';
import { T } from '../../i18n/T';
import Loader from '../../info/Loader';
import { FormContextProvider } from './FormContext';
/**
 * The form is rendered according to the rules. There are 3 ways of rendering:
 * - Automatic rendering of specific elements. An address to the definition
 *   endpoint must be passed. Use API paths from the global config.
 * - Automatic rendering of specific elements. You can pass the the FormDefinition
 *   object directly.
 * - Completely render the form. This occurs if none of the above conditions are met.
 *
 * NOTE: If the definition property is set, it will be preferred before the MobX store
 * definition mechanism.
 */

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));
    /**
     * We need the form store locally, not as global singleton instance. If multiple forms
     * are displayed on the page at one time. Form store will not be visible to others.
     */

    _this.formStore = new FormStore(rootStore);
    /** Form elements that will be removed on the submit event. */

    _this.hiddenFields = new Set();
    _this.formSubmitInterceptors = [];
    /**
     * The form submit event filters out hidden elements.
     */

    _this.onSubmit = function (values, form, callback) {
      var filteredValues = Object.keys(values).filter(function (key) {
        return !_this.hiddenFields.has(key);
      }).reduce(function (obj, key) {
        obj[key] = values[key];
        return obj;
      }, {});
      filteredValues = _this.formSubmitInterceptors.reduce(function (v, fn) {
        return fn(v);
      }, filteredValues);

      _this.props.onSubmit(filteredValues, form, callback);
    };
    /**
     * Render html form element
     */


    _this.renderForm = function (onchange) {
      return function (formRenderProps) {
        var formElement = React.createElement("form", {
          onSubmit: formRenderProps.handleSubmit,
          className: "".concat(_this.props.formLayoutVertical ? 'form-vertical' : 'form-horizontal')
        }, _this.props.children);
        return React.createElement(FormContextProvider, {
          value: {
            formStore: _this.formStore,
            descriptions: _this.props.descriptions,
            hiddenFields: _this.hiddenFields,
            formRenderProps: formRenderProps,
            formSubmitInterceptors: _this.formSubmitInterceptors
          }
        }, onchange ? React.createElement(React.Fragment, null, React.createElement(FormSpy, {
          subscription: {
            values: true
          },
          onChange: function onChange(_ref) {
            var values = _ref.values;
            return onchange(values);
          }
        }), formElement) : formElement);
      };
    };

    _this.init();

    return _this;
  }
  /**
   * Load definition when definitionPath is preset. If the `definitionPath` is not
   * defined, the passed definition is used.
   */


  _createClass(Form, [{
    key: "init",
    value: function init() {
      if (this.props.definition) {
        // Definitions have been enforced in props.
        this.formStore.setFormDefinition(this.props.definition).load(this.props.descriptions);
      } else if (this.props.customDefinition) {
        // Try to load definition
        this.formStore.load(this.props.descriptions, this.props.customDefinition);
      } else {
        this.formStore.load(this.props.descriptions);
      }
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.formStore.loadingState) {
        case LoadingState.Pending:
          return React.createElement(Loader, null);

        case LoadingState.Error:
          // FIXME: BPo Better error handling
          return React.createElement("strong", null, React.createElement(T, {
            id: "err.form-loading-failed"
          }));

        default:
          return React.createElement(FinalForm, {
            onSubmit: this.onSubmit,
            render: this.renderForm(this.props.onChange),
            initialValues: this.props.initialValues,
            subscription: {
              submitting: true
            }
          });
      }
    }
  }]);

  return Form;
}(React.Component);

Form = __decorate([observer, __metadata("design:paramtypes", [Object])], Form);
export default Form;